export enum LoaderRingType {
  Neutral = 'neutral',
  Primary = 'primary',
  Secondary = 'secondary',
  Success = 'success',
  Error = 'error',
  Warning = 'warning'
}

export type LoaderRingWidthOrHeight = `${number}px` | `var(${string})` | null | undefined;
